import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@houzz/ui';
import { withPrefix } from 'gatsby';
import { hzNavigate } from '../utils/navigation';
import { useMatch } from '@reach/router';
import styled from 'styled-components';

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.left-nav__section-link ~ * .left-nav__section-link {
        box-shadow: inset 4px 0 ${(props) => props.theme.colors.border.hover};
    }
    &.left-nav__section-link--partial {
        box-shadow: inset 4px 0 ${(props) => props.theme.colors.border.hover};
    }
    &.left-nav__section-link--active {
        box-shadow: inset 4px 0 ${(props) => props.theme.colors.border.active} !important;
        background-color: ${(props) => props.theme.colors.accentTint};
    }
`;

const LeftNavLink = ({ to, className, linkStyle = 'tertiary', activeLinkStyle = 'secondary', size, children }) => {
    const match = useMatch(`${to}/*`) || useMatch(`/houzz-ui${to}/*`);
    let isPartialMatch = match && match['*'];
    let isFullMatch = match && !isPartialMatch;

    const linkClassName = classNames(className, {
        [`${className}--active`]: isFullMatch,
        [`${className}--partial`]: isPartialMatch,
        [`${className}--matched`]: isPartialMatch || isFullMatch,
    });

    return (
        <StyledLink
            href={withPrefix(to)}
            onClick={(event) => hzNavigate(event, to)}
            size={size}
            fontWeight="bold"
            className={linkClassName}
            linkStyle={isFullMatch ? activeLinkStyle : linkStyle}
            tabIndex={-1}
            py="XXS"
        >
            {children}
        </StyledLink>
    );
};

LeftNavLink.displayName = 'LeftNavLink';
LeftNavLink.propTypes = {
    to: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    linkStyle: PropTypes.string,
    activeLinkStyle: PropTypes.string,
    size: PropTypes.string,
};
export default LeftNavLink;
